import folderStore from 'owa-folders';
import { actionNames } from 'owa-mail-store-actions';
import { subscribe } from 'satcheljs/lib/legacy/stitch';
export default function markAllAsReadStitch() {
    // Refresh folder count when we refresh mail list
    subscribe(actionNames.MarkAllAsReadStoreUpdate, function (tableView, markAsRead) {
        var folderToMarkAsRead = folderStore.folderTable.get(tableView.serverFolderId);
        // Optimistic action
        // folderToMarkAsRead will be null in case of search folders
        if (folderToMarkAsRead != null) {
            folderToMarkAsRead.UnreadCount = markAsRead ? 0 : folderToMarkAsRead.TotalCount;
        }
    });
}
//# sourceMappingURL=markAllAsReadStitch.js.map